import { render, staticRenderFns } from "./RulesConfirmModal.vue?vue&type=template&id=787d12be&scoped=true&"
import script from "./RulesConfirmModal.vue?vue&type=script&lang=js&"
export * from "./RulesConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./RulesConfirmModal.vue?vue&type=style&index=0&id=787d12be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d12be",
  null
  
)

export default component.exports